import router from '@/router'
import store from '@/store'

import helperMixins from '@/mixins/Helper'

const axios = require('axios')

//axios.defaults.baseURL = process.env.VUE_APP_API_BASE
axios.defaults.baseURL = 'https://test.muluntech.com/api/system/v1';

axios.interceptors.request.use(
    (config) => {
        if (config.url !== '/login' && config.url.indexOf('/password') === -1) {
            const token = store.state.admin.jwt.access_token
            config.headers.Authorization = `Bearer ${token}`
        }

        return config
    },
    (err) => {
        console.log('axios request err', err)

        return Promise.reject(err)
    })

axios.interceptors.response.use(
    (res) => {
        return Promise.resolve(res)
    },
    (err) => {
        console.log('axios response err', err)

        return Promise.reject(err)
    })

export default {
    handling: (result) => {
        helperMixins.methods.toggleLoading(true)

        return result
            .then((res) => {
                helperMixins.methods.toggleLoading(false)

                // 連線失敗、不合法的使用者、需登入、無法分辨的錯誤
                if ([10000, 30001, 30002, 90000].indexOf(res.status) !== -1) {
                    store.dispatch('system/set_snackbar', {
                        color: "error",
                        text: "請重新登入"
                    })

                    router.push('/login')
                    helperMixins.methods.toggleLoading(false)
                }

                return res.data
            })
            .catch((err) => {
                console.log(err)
                //debugger
                // if (err.response.status === 401) {
                //     store.dispatch('system/set_snackbar', {
                //         color: "error",
                //         text: "請重新登入"
                //     })
                // } else {
                //     store.dispatch('system/set_snackbar', {
                //         color: "error",
                //         text: "系統異常，若持續發生錯誤，請聯絡管理員"
                //     })
                // }

                // router.push('/login')
                // helperMixins.methods.toggleLoading(false)
            })
    }
}
